/**
 * Notification_Service API client (task 21.2).
 *
 * | Method / Path                  | Function                      | Req. |
 * | ------------------------------ | ----------------------------- | ---- |
 * | `GET /notifications/preference`| {@link getNotificationPreference} | R7.7 |
 * | `PUT /notifications/preference`| {@link setNotificationPreference} | R7.7 |
 * | `GET /notifications`           | {@link getNotificationLog}    | R7.5 |
 */

import { apiGet, apiPut } from './client.js';
import type { NotificationLogEntry, NotificationPreference } from './types.js';

/**
 * Read the current stored notification preference (R7.7). The service returns
 * the implicit `{ enabled: false, channel: null }` default when the customer
 * has never saved one, so this never 404s.
 */
export function getNotificationPreference(): Promise<NotificationPreference> {
  return apiGet<NotificationPreference>('/notifications/preference');
}

/**
 * Enable or disable transaction notifications (R7.7 — the change applies to
 * transactions posted more than 5s later). Returns the stored preference.
 */
export function setNotificationPreference(
  enabled: boolean,
  channel?: string,
): Promise<NotificationPreference> {
  return apiPut<NotificationPreference>('/notifications/preference', {
    enabled,
    ...(channel !== undefined ? { channel } : {}),
  });
}

/** Retrieve the notification log, including retained failures (R7.5). */
export function getNotificationLog(): Promise<{
  notifications: NotificationLogEntry[];
}> {
  return apiGet<{ notifications: NotificationLogEntry[] }>('/notifications');
}
